import { IUsuario } from "@/models/usuario.model";

export const initialState : IUsuario | null = null;
